(function () {
    'use strict';

    angular
        .module('app')
        .controller('OrderOptionAddCtrl', OrderOptionAddCtrl);

    OrderOptionAddCtrl.$inject = ['orderOption', 'entityFields', 'DialogInstance'];

    function OrderOptionAddCtrl(orderOption, entityFields, DialogInstance) {
        /* jshint validthis:true */
        var vm = this;
        vm.ok = ok;
        vm.cancel = cancel;
        vm.entityFields = [];
        vm.orderOption = newOrderOption();
        vm.addField = addField;
        vm.deleteField = deleteField;

        activate();

        function activate() {
            if (!angular.isUndefined(orderOption) && orderOption !== null && orderOption != 'new') {
                vm.title = 'Order Option';
                vm.orderOption = angular.copy(orderOption);
            } else {
                vm.title = 'Add Order Option';
            }

            vm.entityFieldList = [{ Name: 'System: Id', Reference: 'id' }, { Name: 'System: Updated Date', Reference: 'updated_date' },
                { Name: 'System: Created Date', Reference: 'created_date' }, { Name: 'System: Email Address', Reference: 'system:entity_email_address' },
                { Name: 'System: Item Count', Reference: 'system:item_count' }, { Name: 'System: Task Count', Reference: 'system:task_count' }];
            vm.orderFieldList = [{Name: 'Ascending', Reference: 'asc'}, {Name: 'Descending', Reference: 'desc'}];

            if (!_.isNil(entityFields)) {
                angular.forEach(entityFields, function (entityField) {
                    var entityFieldCopy = angular.copy(entityField);
                    entityFieldCopy.Reference = 'fields|' + entityField.Name;
                    vm.entityFieldList.push(entityFieldCopy);
                });

                vm.entityFields = angular.copy(entityFields);
            }
        }


        function ok() {
            DialogInstance.ok(vm.orderOption);
        }

        function cancel() {
            DialogInstance.cancel();
        }

        function addField() {
            vm.orderOption.Fields.push({ Name: 'id', Order: 'asc' });
        }

        function deleteField(index) {
            vm.orderOption.Fields.splice(index, 1);
        }

        function newOrderOption() {
            return {
                Name: '',
                Default: false,
                Fields: []
            };
        }
    }
})();
